<template>
  <!-- Top Black Utility Bar -->
  <nav
    class="omnibar"
    :class="{ showSidebar: isShowSidebar, mobile: isMobile }"
  >
    <div class="container omnibar__container omnibar__container--full-width">
      <div class="omnibar__group-left">
        <div class="omnibar-logo__container">
          <a href="https://www.apnic.net/">
            <img
              class="omnibar-logo__image"
              src="https://webdist.data.apnic.net/web-framework-theme/8.0.0/images/apnic-reverse.svg"
              alt="APNIC Logo"
            />
          </a>
        </div>
      </div>
      <div class="omnibar__group-right">
        <!-- external links section -->
        <div class="dropdown" v-click-outside="clickOutsideOfLinksDropdown">
          <!-- external links toggle button -->
          <button
            class="omnibar-hamburger__toggle omnibar-hamburger__toggle--desktop dropdown-toggle"
            id="omnibarHamburgerButton"
            data-toggle="dropdown"
            aria-haspopup="true"
            aria-expanded="false"
            @click="toggleIsShowLinksDropdown"
          >
            <img
              class="omnibar-hamburger__icon"
              src="../../assets/icon-square-kebab.svg"
              aria-hidden="true"
            />
          </button>
          <!-- external links dropdown list -->
          <div
            v-if="isShowLinksDropdown"
            class="dropdown-menu dropdown-menu-right omnibar-quick-links__wrap d-block"
            aria-labelledby="omnibarHamburgerButton"
          >
            <a
              class="dropdown-item omnibar-quick-links__link"
              href="https://my.apnic.net/"
            >
              <span>MyAPNIC</span>
            </a>
            <a
              class="dropdown-item omnibar-quick-links__link"
              href="https://academy.apnic.net/"
            >
              <span>Academy</span>
            </a>
            <a
              class="dropdown-item omnibar-quick-links__link"
              href="https://blog.apnic.net/"
            >
              <span>Blog</span>
            </a>
            <a
              class="dropdown-item omnibar-quick-links__link"
              href="https://rex.apnic.net/"
            >
              <span>REx</span>
            </a>
            <a
              class="dropdown-item omnibar-quick-links__link"
              href="https://netox.apnic.net/"
            >
              <span>NetOX</span>
            </a>
            <a
              class="dropdown-item omnibar-quick-links__link"
              href="https://dash.apnic.net/"
            >
              <span>DASH</span>
            </a>
          </div>
        </div>
        <!-- LOG IN button -->
        <a
          v-if="!oidcIsAuthenticated"
          class="omnibar-primary-action__button"
          @click="authenticateOidc"
        >
          <span class="omnibar-primary-action__button-text">Log in</span>
        </a>
        <!-- user profile section -->
        <div
          v-if="oidcIsAuthenticated"
          class="dropdown"
          v-click-outside="clickOutsideOfUserProfileDropDown"
        >
          <!-- user profile dropdown toggle button -->
          <button
            class="dropdown-toggle omnibar-current-user__toggle"
            id="omnibarCurrentUserButton"
            aria-haspopup="true"
            aria-expanded="false"
            @click="toggleIsShowUserProfileDropDown"
          >
            <i
              class="fas fa-user-circle omnibar-current-user__toggle-icon"
              aria-hidden="true"
            ></i>
          </button>
          <!-- user profile dropdown list -->
          <div
            v-if="isShowUserProfileDropDown"
            class="dropdown-menu dropdown-menu-right omnibar-current-user__menu d-block"
            aria-labelledby="omnibarCurrentUserButton"
          >
            <div class="omnibar-current-user__hello">
              Hello, {{ userName }}!
            </div>
            <hr class="omnibar-current-user__menu-hr" />
            <a
              class="dropdown-item omnibar-current-user__menu-link"
              :href="myApnicDashboardURL"
            >
              <span>MyAPNIC</span>
            </a>
            <a
              class="dropdown-item omnibar-current-user__menu-link"
              :href="personalSettingsURL"
            >
              <span>Personal profile</span>
            </a>
            <a
              class="dropdown-item omnibar-current-user__menu-link"
              :href="personalSettingsURL"
            >
              <span>Passwords &amp; Security</span>
            </a>
            <hr class="omnibar-current-user__menu-hr" />
            <a
              class="dropdown-item omnibar-current-user__menu-link"
              :href="linkExistingMembership"
            >
              <span>Link existing membership</span>
            </a>
            <a
              class="dropdown-item omnibar-current-user__menu-link"
              :href="membershipApplication"
            >
              <span>New membership application</span>
            </a>
            <a
              class="dropdown-item omnibar-primary-action__button mt-2"
              @click="signOutOidc"
            >
              <span class="omnibar-primary-action__button-text">Log out</span>
            </a>
          </div>
        </div>
      </div>
    </div>
  </nav>
</template>

<script>
import { mapGetters, mapActions, mapState } from 'vuex';
import { oidcRoot } from '../../config/oidc';
import mixin from '../../utils/mixin';
import * as vClickOutside from 'v-click-outside';
import { profileSectionURLs } from '../../config/oidc';

export default {
  mixins: [mixin],
  directives: {
    clickOutside: vClickOutside.directive
  },
  props: ['isShowSidebar'],
  data() {
    return {
      oidcRoot,
      isShowLinksDropdown: false,
      isShowUserProfileDropDown: false,
      personalSettingsURL: profileSectionURLs.personalSettingsURL,
      myApnicDashboardURL: profileSectionURLs.myApnicDashboardURL,
      linkExistingMembership: profileSectionURLs.linkExistingMembership,
      membershipApplication: profileSectionURLs.membershipApplication
    };
  },

  computed: {
    ...mapState('authStore', ['user']),

    userName() {
      if (!this.user) return '';

      return this.user.nickname || this.user.name || this.user.email || '';
    }
  },
  methods: {
    ...mapActions('authStore', ['signOutOidc', 'authenticateOidc']),

    toggleIsShowLinksDropdown() {
      this.isShowUserProfileDropDown &&
        (this.isShowUserProfileDropDown = false);
      this.isShowLinksDropdown = !this.isShowLinksDropdown;
    },

    toggleIsShowUserProfileDropDown() {
      this.isShowLinksDropdown && (this.isShowLinksDropdown = false);
      this.isShowUserProfileDropDown = !this.isShowUserProfileDropDown;
    },

    clickOutsideOfLinksDropdown() {
      this.isShowLinksDropdown && (this.isShowLinksDropdown = false);
    },

    clickOutsideOfUserProfileDropDown() {
      this.isShowUserProfileDropDown &&
        (this.isShowUserProfileDropDown = false);
    }
  }
};
</script>

<style lang="scss" scoped>
nav.omnibar {
  position: fixed;
  top: 0;
  z-index: 9;
  width: 100%;
  margin-bottom: 0 !important;
}

.omnibar-current-user__menu {
  z-index: 9;
}

.mobile.omnibar {
  position: relative;

  &.showSidebar {
    z-index: 1;
  }
}
</style>
